module.exports = __webpack_public_path__ + "img/icon_text.532e7959.svg";